<template>
	<div style="margin-top: 30px">
		<el-table header-row-class-name="btClass" :data="tableData" :span-method="objectSpanMethod" border style="width: 100%">
			<el-table-column align="center" prop="tNum" width="89" label="子题"></el-table-column>
			<el-table-column align="center" prop="xuanx" width="89" label="选项">
				<template slot-scope="scope">
					<div class="xsFont" :class="scope.row.isBlank ? 'xsBlank' : scope.row.fenbmd != '正确' ? 'xsRed' : ''">
						{{ scope.row.xuanx }}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="fenbmd" align="center" label="分布名单">
				<template slot-scope="scope">
					<div class="zqBox" v-if="scope.row.fenbmd == '正确'">
						<img src="@/assets/img/zq.svg" alt="" />
						<span>正确答案</span>
					</div>
					<div v-else class="fenBox">
						<div class="fenItem" v-for="(item, index) in scope.row.fenbmd?.split(',').filter((item) => item != '')" :key="index">
							{{ item }}
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="hej" width="89" label="合计">
				<template slot-scope="scope">
					<div :class="scope.row.isBlank ? 'xsBlank' : scope.row.fenbmd != '正确' ? 'xsRed' : 'xsGre'">
						{{ scope.row.hej }}
					</div>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
export default {
	name: 'ctHz',
	data() {
		return {};
	},
	props: ['tableData'],
	methods: {
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
				const groupValue = row.groupKey != null ? row.groupKey : row.tNum;
				const previousRow = this.tableData[rowIndex - 1];
				const previousGroupValue = previousRow && (previousRow.groupKey != null ? previousRow.groupKey : previousRow.tNum);
				if (rowIndex > 0 && previousGroupValue === groupValue) {
					return {
						rowspan: 0,
						colspan: 0
					};
				}

				let rowspan = 1;
				for (let index = rowIndex + 1; index < this.tableData.length; index++) {
					const nextRow = this.tableData[index];
					const nextGroupValue = nextRow.groupKey != null ? nextRow.groupKey : nextRow.tNum;
					if (nextGroupValue !== groupValue) break;
					rowspan++;
				}
				return { rowspan, colspan: 1 };
			}
		}
	},
	mounted() {}
};
</script>
<style lang="scss" scoped>
::v-deep .btClass {
	background: #f4fbf8 !important;
	th {
		background: #f4fbf8 !important;
	}
	.cell {
		font-size: 14px !important;
		color: #000000 !important;
		font-weight: bold !important;
	}
}

::v-deep .el-table tbody tr:hover > td {
	background: transparent !important;
}
::v-deep .el-table__body tr.current-row > td.el-table__cell {
	background: transparent !important;
}
.xsFont {
	font-size: 14px;
	color: #000;
	font-weight: bold;
}
.xsRed {
	color: #fa4a1b;
}
.xsGre {
	color: #1d7b3a;
}
.xsBlank {
	color: #d97706;
}
.fenBox {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	.fenItem {
		padding: 2px 7px 2px 9px;
		background: #f4f4f4;
		border-radius: 2px;
		font-size: 14px;
		color: #000000;
		margin-right: 8px;
	}
}
.zqBox {
	font-size: 14px;
	color: #1d7b3a;
	display: flex;
	align-items: center;
	justify-content: center;
	img {
		width: 18px;
		height: 18px;
		margin-right: 3px;
	}
}
</style>
